module.exports = window.__loadPromiseRequirejs__("@wix/wix-code-classic-editor");